import React from 'react';
import { PartnerDeckNav } from '../components/deck/PartnerDeckNav';
import {
  SlideTitle,
  SlideProblem,
  SlideSolution,
  SlideValue,
  SlidePartnershipSkillGrid,
  SlideCaseStudyHighlight,
  SlideCaseStudyValue,
  SlideCaseStudyImpact,
  SlideCompetitive,
  SlideDemoVideos,
  SlideClosing,
} from '../components/deck/DeckSlides';

/**
 * Partner deck: for construction software partners (e.g. BuildOps). Focus on
 * partnership language, co-sell opportunities, and Jobotics Skill Grid.
 * Access at /partner-deck (e.g. https://demo.jobotics.ai/partner-deck).
 */
export default function PartnerDeck() {
  return (
    <div className="min-h-screen bg-white">
      <PartnerDeckNav />
      <main className="deck-export relative">
        <SlideTitle forPartner />
        <SlideProblem forPartner />
        <SlideSolution forPartner />
        <SlideValue forPartner />
        <SlidePartnershipSkillGrid />
        <SlideCaseStudyHighlight forPartner />
        <SlideCaseStudyValue />
        <SlideCaseStudyImpact />
        <SlideCompetitive forPartner />
        <SlideDemoVideos />
        <SlideClosing forPartner />
      </main>
    </div>
  );
}
